import axios from 'axios';

const CSRF_COOKIE_URL = process.env.REACT_APP_API_URL?.replace('/api/v1', '') || 'http://localhost:8000';

export const initializeCsrf = async (): Promise<void> => {
  try {
    await axios.get(`${CSRF_COOKIE_URL}/sanctum/csrf-cookie`, {
      withCredentials: true,
    });
  } catch (error) {
    console.warn('Failed to initialize CSRF token:', error);
  }
};

export default initializeCsrf;